import { render, staticRenderFns } from "./StudentCompAnalytics.vue?vue&type=template&id=7ab3eec2"
import script from "./StudentCompAnalytics.vue?vue&type=script&lang=js"
export * from "./StudentCompAnalytics.vue?vue&type=script&lang=js"
import style0 from "./StudentCompAnalytics.vue?vue&type=style&index=0&id=7ab3eec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports